import Organization from 'classes/Organization';
import { ApiRequest, deleteItem, patchItem, postItem } from './ApiUtils';
import ODataUtil from './ODataUtil';
import buildQuery from 'odata-query';

const apiEndpoint = "/Organization";

const getOrganizations = async (page, per_page, orderByInfo, orderByDirection, search, filters) => {
    const { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
        per_page, page, Organization.expand, orderByInfo, orderByDirection, filters
    ); 

    const filter = {};

    const allFilters = mappedFilter.reduce((a, b) => ({ ...a, ...b }), filter);
    const params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });
    const res = await ApiRequest(apiEndpoint, params);

    const data = Organization.convertToTableRows(res);

    return data;
};

const addOrganization = async (data) => {
    delete data.organizationId;
    const endpoint = `${apiEndpoint}/Add`;
    const resp = await postItem(endpoint, '', data);
    console.log(resp);
    return resp;
};

const updateOrganization = async (data) => {
    // const upperCaseData = Object.keys(data).reduce((a, b) => ({...a, [`${b.substr(0,1).toUpperCase()}${b.substr(1)}`]: data[b]}), {});
    const urlParams = `?organizationId=${data.organizationId}`;
    const endpoint = `${apiEndpoint}/Update`;
    const res = await patchItem(endpoint, urlParams, data);
    return res;
};

// delete from the editGrid HOC always returns projectId;
const deleteOrganization = async (projectId, data) => {
    const endpoint = `${apiEndpoint}/Delete`;
    const urlParams = `?organizationId=${data.organizationId}`
    const res = await deleteItem(endpoint, urlParams, data);
    return res;
};

export { getOrganizations, addOrganization, updateOrganization, deleteOrganization };